export const queryKeys = {
  auth: {
    me: () => ["auth", "me"] as const,
  },
  admin: {
    all: ["admin"] as const,
    me: () => ["admin", "me"] as const,
    profiles: () => ["admin", "profiles"] as const,
    sources: (profileSlug: string) => ["admin", "sources", profileSlug] as const,
  },
  pulse: {
    profiles: (profileSlug?: string) => ["pulse", "profiles", profileSlug ?? "default"] as const,
    latest: (profileSlug?: string) => ["pulse", "latest", profileSlug ?? "default"] as const,
    editions: (profileSlug?: string) => ["pulse", "editions", profileSlug ?? "default"] as const,
    edition: (fecha: string, profileSlug?: string) =>
      ["pulse", "edition", fecha, profileSlug ?? "default"] as const,
    weeklyFeatures: (limit: number, profileSlug?: string) =>
      ["pulse", "weekly-features", limit, profileSlug ?? "default"] as const,
  },
} as const;
